<script lang="ts">
import { defaultRenderCell } from '@park-ui/components/table/src/config'
import { TableColumnCtx } from '@park-ui/components/table/src/table-column/defaults'
import { TABLE_INJECTION_KEY } from '@park-ui/components/table/src/tokens'
import ElTooltip from '@park-ui/components/tooltip'
import { hasClass } from '@park-ui/utils'
import { defineComponent, h, inject, PropType, reactive, ref } from 'vue'

type ColumnRowType<T> = {
  row: T
  column: TableColumnCtx<T>
  $index: number
  placeholder: string
}

export default defineComponent({
  props: {
    index: {
      type: Number,
    },
    pageSize: {
      type: Number,
    },
    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipWidth: {
      type: [Number, String],
    },
    data: {
      type: Object as PropType<ColumnRowType<any>>,
    },
  },
  setup(props, ctx) {
    const propConfig = reactive(props)
    const index = propConfig.data!.$index
    const pageSize = propConfig.pageSize! / 2
    const prefix = index > pageSize ? 'top' : 'bottom'
    const disabled = ref(!propConfig.showOverflowTooltip)
    const parent = inject(TABLE_INJECTION_KEY)
    function onTooltipMouseenter(event: {
      [x: string]: any
      target: HTMLElement
    }) {
      onMaxWidthChange()
      const namespace = parent?.vnode.el?.dataset.prefix
      const target = event.target as HTMLElement
      const cellChild = target.parentElement?.parentElement!.querySelector(
        '.cell'
      ) as HTMLElement
      if (!hasClass(cellChild, `${namespace}-tooltip`)) {
        // 24是固定值，不可取
        if (target.scrollWidth + 24 < maxWidth.value) {
          disabled.value = true
        }
      } else {
        disabled.value = false
      }
    }
    const maxWidth = ref<number>(0)
    function onMaxWidthChange() {
      maxWidth.value = propConfig.tooltipWidth! as number
      if (!propConfig.tooltipWidth) {
        const dom: Array<any> = document.getElementsByClassName(
          propConfig.data!.column.id
        ) as any
        if (dom.length > 0) {
          maxWidth.value = dom[0].offsetWidth
        }
      }
    }
    return {
      propConfig,
      disabled,
      prefix,
      onTooltipMouseenter,
      maxWidth,
    }
  },
  render() {
    const content = defaultRenderCell(this.propConfig.data!)
    return h(
      'div',
      {
        onmouseover: this.onTooltipMouseenter,
      },
      [
        h(
          ElTooltip,
          {
            placement: this.prefix,
            disabled: this.disabled,
          } as any,
          {
            content: () =>
              h(
                'div',
                {
                  style: {
                    maxWidth: this.maxWidth + 'px',
                  },
                },
                [content]
              ),
            default: () => [content],
          }
        ),
      ]
    )
  },
})
</script>
